import { memo, type ReactNode } from 'react';

import { Gear } from '@air/next-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Popover } from '@air/primitive-popover';

import { CONFIG_VIEWS_VISIBILITY } from '~/constants/testIDs';
export type ViewVisibilityToggleMenuProps = {
  children: ReactNode;
};

export const ViewVisibilityToggleMenu = memo(({ children }: ViewVisibilityToggleMenuProps) => {
  return (
    <Popover
      side="bottom"
      align="end"
      size="large"
      trigger={
        <IconButton
          appearance="ghost"
          color="grey"
          size="small"
          label="Visibility Toggles"
          data-testid={CONFIG_VIEWS_VISIBILITY}
          icon={Gear}
        />
      }
    >
      {children}
    </Popover>
  );
});

ViewVisibilityToggleMenu.displayName = 'ViewVisibilityToggleMenu';
